// @todo remove hack chrome96Bug
export function forceReloadChrome96Bug() {
  const d = document.querySelectorAll("#map svg")[0];
  if (d) {
    d.innerHTML += "";
  }
}
